// extracted by mini-css-extract-plugin
export default {"icon":"Y0ECS"};